export default {"src":"/_next/static/media/0x1a4b46696b2bb4794eb3d4c26f1c55f9170fa4c5.80530a75.svg","height":2500,"width":2500,"blurWidth":0,"blurHeight":0};